import React from "react";
import { useOutletContext } from "react-router-dom";
import InsertBtn from "../../../components/WriteProject/InsertBtn/InsertBtn";
import RewardCard from "../../../components/WriteProject/RewardCard/RewardCard";
import WpTitle from "../../../components/WriteProject/WpTitle/WpTitle";
import { ProjectType } from "../../../interface/interface";

function Step4() {
  const {
    state: { rewards },
    UpdateCommon,
  }: {
    state: ProjectType;
    UpdateCommon: (
      type: string,
      payload: string | number,
      index: number | undefined
    ) => void;
  } = useOutletContext();

  return (
    <div className="step4">
      <WpTitle title="완주 보상" />
      <div className="card-wrapper">
        {rewards.map((item, idx) => {
          return (
            <RewardCard
              key={idx}
              data={item}
              index={idx}
              __update={UpdateCommon}
            />
          );
        })}
      </div>
      <InsertBtn
        title="완주보상 입력란 추가"
        __init={UpdateCommon}
        type="rewards/add"
      />
    </div>
  );
}

export default Step4;
